export enum CarInsuranceType {
  AUTO_DRIVER_AND_PASSENGER_ACCIDENT = "carAnsvar",
  AUTO_FULL_OWN_DAMAGE = "carKasko",
  AUTO_REDUCED_OWN_DAMAGE = "carDelKasko",
  AUTO_FULL_OWN_DAMAGE_INCLUDING_RENTALCAR = "carKaskoLeiebil",
  AUTO_FULL_OWN_DAMAGE_INCLUDING_RENTALCAR_EXTENDED = "carKaskoLeiebilUtvidet",
  AUTO_FULL_SUPER_V2 = "carSuper",
  AUTO_FULL_SUPER_V2_INCLUDING_RENTALCAR = "carSuperLeiebil",
  AUTO_FULL_SUPER_V2_INCLUDING_RENTALCAR_EXTENDED = "carSuperLeiebilUtvidet",
}
